module.exports = "/_next/static/resources/photo-3-c9b646334edb7f06cbab0ef3de55cb2f.webp";